import Button from '../../../../Button'
import { Divider } from '../../../../Divider'
import { IconNG } from '../../../../Icon'
import { Skeleton } from '../../../../Skeleton'
import { QA_NAME_PROVIDER_EDIT_BUILDING_AND_CATEGORY_DELETE_MAPPING_ROW_BTN } from '../../EditBuildingAndCategoryModal.constants'
import { getQaNameMappingRowDeleteButton } from '../../EditBuildingAndCategoryModal.utils'
import { BuildingField } from '../BuildingField'
import { CategoryField } from '../CategoryField'

import * as styles from '../EditBuildingAndCategoryModalFormFields.module.css'

import DeleteIcon from '../../../../../icons/delete.svg'
import UnionIcon from '../../../../../icons/link-1.svg'

function MappingRow({
  deleteTooltip,
  deleteTooltipPlacement,
  index,
  isDeleteDisabled,
  isLoading,
  isSubmitting,
  onRemoveMappingRow,
}) {
  function handleRemoveMappingRow() {
    onRemoveMappingRow(index)
  }

  return (
    <div className={styles.mappingRow}>
      <div className={styles.fields}>
        <CategoryField
          index={index}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
        />
        <div className={styles.link}>
          {isLoading ? (
            <Skeleton className={styles.linkSkeleton} />
          ) : (
            <IconNG Icon={UnionIcon} />
          )}
        </div>
        <BuildingField
          index={index}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
        />
        <div className={styles.delete}>
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: DeleteIcon }}
            disabled={isDeleteDisabled}
            isSkeleton={isLoading}
            qaName={getQaNameMappingRowDeleteButton(
              QA_NAME_PROVIDER_EDIT_BUILDING_AND_CATEGORY_DELETE_MAPPING_ROW_BTN,
              index
            )}
            tooltip={deleteTooltip}
            tooltipPlacement={deleteTooltipPlacement}
            onClick={handleRemoveMappingRow}
          />
        </div>
      </div>
      {!isLoading ? <Divider className={styles.divider} /> : null}
    </div>
  )
}

export default MappingRow
